export const ADD_MESSAGE = '@@reservble/chatbot/ADD_MESSAGE';
export const REPLACE_HISTORY = '@@reservble/chatbot/REPLACE_HISTORY';
